import config from '@/config'
import {ADMIN} from '@/config/default'
import {formatFullPath} from '@/utils/i18n'
import {filterMenu} from '@/utils/authority-utils'
import {getLocalSetting} from '@/utils/themeUtil'

const localSetting = getLocalSetting(true)
const customTitlesStr = localStorage.getItem(process.env.VUE_APP_TBAS_TITLES_KEY)
const customTitles = (customTitlesStr && JSON.parse(customTitlesStr)) || []

export default {
  namespaced: true,
  state: {
    isMobile: false,
    animates: ADMIN.animates,
    palettes: ADMIN.palettes,
    pageMinHeight: 0,
    menuData: [],
    activatedFirst: undefined,
    customTitles,
    ...config,
    ...localSetting,
    collapsed: false,
    count: 0,
  },
  getters: {
    menuData(state, getters, rootState) {
      if (state.filterMenu) {
        const {permissions, roles} = rootState.account
        filterMenu(state.menuData, permissions, roles)
      }
      return state.menuData
    },
    firstMenu(state) {
      const {menuData} = state
      if (menuData.length > 0 && !menuData[0].fullPath) {
        formatFullPath(menuData)
      }
      return menuData.map(item => {
        const menuItem = {...item}
        delete menuItem.children
        return menuItem
      })
    },
    subMenu(state) {
      const {menuData, activatedFirst} = state
      if (menuData.length > 0 && !menuData[0].fullPath) {
        formatFullPath(menuData)
      }
      const current = menuData.find(menu => menu.fullPath === activatedFirst)
      return current && current.children || []
    }
  },
  mutations: {
    setCount(states, count) {
      const state = states
      state.count = count
    },
    setCollapsed(states, collapsed) {
      const state = states
      state.collapsed = collapsed
    },
    setDevice (states, isMobile) {
      const state = states
      state.isMobile = isMobile
    },
    setTheme (states, theme) {
      const state = states
      state.theme = theme
    },
    setLayout (states, layout) {
      const state = states
      state.layout = layout
    },
    setMultiPage (states, multiPage) {
      const state = states
      state.multiPage = multiPage
    },
    setAnimate (states, animate) {
      const state = states
      state.animate = animate
    },
    setWeekMode(states, weekMode) {
      const state = states
      state.weekMode = weekMode
    },
    setFixedHeader(states, fixedHeader) {
      const state = states
      state.fixedHeader = fixedHeader
    },
    setFixedSideBar(states, fixedSideBar) {
      const state = states
      state.fixedSideBar = fixedSideBar
    },
    setLang(states, lang) {
      const state = states
      state.lang = lang
    },
    setHideSetting(states, hideSetting) {
      const state = states
      state.hideSetting = hideSetting
    },
    correctPageMinHeight(states, minHeight) {
      const state = states
      state.pageMinHeight += minHeight
    },
    setMenuData(states, menuData) {
      const state = states
      state.menuData = menuData
    },
    setAsyncRoutes(states, asyncRoutes) {
      const state = states
      state.asyncRoutes = asyncRoutes
    },
    setPageWidth(states, pageWidth) {
      const state = states
      state.pageWidth = pageWidth
    },
    setActivatedFirst(states, activatedFirst) {
      const state = states
      state.activatedFirst = activatedFirst
    },
    setFixedTabs(states, fixedTabs) {
      const state = states
      state.fixedTabs = fixedTabs
    },
    setCustomTitle(state, {path, title}) {
      if (title) {
        const obj = state.customTitles.find(item => item.path === path)
        if (obj) {
          obj.title = title
        } else {
          state.customTitles.push({path, title})
        }
        localStorage.setItem(process.env.VUE_APP_TBAS_TITLES_KEY, JSON.stringify(state.customTitles))
      }
    },
  }
}
